<template>
  <v-container class="container pt-5">
    <h2>Urlaubsplanung</h2>
    <VDateInput variant="underlined" 
      label="Deadline" 
      cancel-text="Abbrechen"
      ok-text="OK"
      :v-model="deadline" />

    <v-row class="d-flex justify-center">
      <v-btn-toggle mandatory  variant="outlined" v-model="selectedDate" class="mb-1">
        <v-btn width="*" variant="plain" color="primary" value="von">von</v-btn>
        <v-btn width="*" variant="plain" color="primary" value="bis">bis</v-btn>
      </v-btn-toggle>
    </v-row>
    <v-calendar
        class="mb-2"
        transparent
        expanded
        borderless
        mode="dateTime"
        :attributes="attributes"
        @dayclick="dayClick"
    />
    
    <VCheckbox class="mb-2 v-checkbox--default" label="Gesperrt" v-model="locked"></VCheckbox>
    <VCheckbox class="mb-2 v-checkbox--default" label="Versteckt" v-model="hidden"></VCheckbox>
    <v-row class="d-flex justify-center mt-4 mb-4">
      <v-btn color="secondary" @click="onCancel" class="mb-2">Zurück</v-btn>
      <v-btn color="primary" @click="onSave" class="ml-2">Speichern</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import {ref, watch} from "vue";
import {CheckVacationPeriod} from "@/data/vacationPeriod";
import {notifyError} from "vuetify3-dialog";
export default {
  components: {
    VCheckbox: () => import('@new-mg/vuetify-new-theme'),
  },
  props: {
    period: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const year = ref(props.period ? props.period.year : new Date().getFullYear());
    const startDate = ref(props.period ? props.period.startDate?.toDate() : null);
    const endDate = ref(props.period ? props.period.endDate?.toDate() : null);
    const locked = ref(props.period ? props.period.locked : false);
    const hidden = ref(props.period ? props.period.hidden : true);
    const deadline = ref(props.period ? props.period?.deadline?.toDate() : new Date());
    const readyToUpload = ref(props.period ? props.period.readyToUpload : false)
    const readyToDownload = ref(props.period ? props.period.readyToDownload : false)
    const uploaded = ref(props.period ? props.period.uploaded : false)
    const downloaded = ref(props.period ? props.period.downloaded : false)
    const selectedDate = ref('von');
    const IsNew = props.period === null;
    
    const attributes = ref([
      {
        highlight: 'green',
        dates: [[startDate.value, endDate.value]],
      },
    ]);

    const refreshAttributes = () => {
      attributes.value[0].dates = [[startDate.value, endDate.value]];
    };

    watch(startDate, refreshAttributes);
    watch(endDate, refreshAttributes);
    
    watch(startDate, () => {
      if(startDate.value) {
        year.value = startDate.value.getFullYear();
      }
    });
    
    const dayClick = (date) => {
      if(selectedDate.value === 'von') {
        startDate.value = date.date;

        if(endDate.value === null) {
          endDate.value = startDate.value;
        }

        selectedDate.value = 'bis';
      } else {
        endDate.value = date.date;
      }
    };
    
    return {deadline,locked, hidden, year, attributes, dayClick, selectedDate, startDate, 
      endDate, IsNew, readyToUpload, readyToDownload, uploaded, downloaded};
  },
  methods: {
    onSave(){
      CheckVacationPeriod(this.year.toString()).then((result) => {
        const exists = this.IsNew && result;
        
        if(exists)
        {
          notifyError('Ein Urlaubszeitraum für dieses Jahr existiert bereits');
        }
        else
        {
          this.$emit('vacationperiod-save',
              { year: this.year,
                locked: this.locked,
                hidden: this.hidden,
                deadline: this.deadline,
                startDate: this.startDate,
                readyToUpload: this.readyToUpload,
                readyToDownload: this.readyToDownload,
                uploaded: this.uploaded,
                downloaded: this.downloaded,
                endDate: this.endDate});
        }
      });
    },
    onCancel() {
      this.$emit('vacationperiod-back', false);
    },
  },
};
</script>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>